<template>
  <v-btn
    v-bind="$attrs"
    :color="color"
    class="action-button"
    elevation="0"
    :disabled="loading || disabled"
    :append-icon="appendIcon && !loading && appkitIcon ? iconClass : ''"
    :variant="variant"
  >
    <template v-if="appendIcon" v-slot:append>
      <AppkitIcon
        v-if="!!appkitIcon"
        class="icon-transition-right"
        :class="loading ? 'hidden' : ''"
        :icon="appkitIcon"
        :size="iconSize"
      />
    </template>
    <template v-if="prependIcon" v-slot:prepend>
      <AppkitIcon
        v-if="!!appkitIcon"
        class="icon-transition-left"
        :class="loading ? 'hidden' : ''"
        :icon="appkitIcon"
        :size="iconSize"
      />
    </template>
    <div :class="{ hidden: loading }">
      <slot />
    </div>
    <PSpinner v-if="loading" :primary="PwcTheme.colors.primarySpinner" />
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from "vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { PwcTheme } from "@/plugins/pwc-theme";
import PSpinner from "@/components/custom/buttons/PSpinner.vue";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    loading?: boolean;
    appkitIcon?: string;
    appendIcon?: boolean;
    prependIcon?: boolean;
    iconSize?: "xs" | "small" | "medium" | "large";
    variant?: "outlined" | "tonal" | "text" | "plain";
    color?: string;
  }>(),
  {
    disabled: false,
    loading: false,
    appkitIcon: "",
    color: "primaryButton",
  }
);

const iconClass = computed(() => {
  return "Appkit4-icon " + props.appkitIcon + props.iconSize;
});
</script>

<style scoped lang="scss">
.hidden {
  opacity: 0;
}

.action-button {
  border-radius: 6.3px;
}

button {
  .icon-transition-right {
    transition: ease-in-out 200ms;
  }
  .icon-transition-left {
    transition: ease-in-out 200ms;
  }

  &:hover {
    .icon-transition-right {
      transform: translateX(4px);
    }
    .icon-transition-left {
      transform: translateX(-4px);
    }
  }
}
</style>
